import { render, staticRenderFns } from "./PricingCardsDesktop.vue?vue&type=template&id=ed3cea5a&"
import script from "./PricingCardsDesktop.vue?vue&type=script&lang=js&"
export * from "./PricingCardsDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports